import { render, staticRenderFns } from "./menu2_3.vue?vue&type=template&id=65f43768&scoped=true&"
import script from "./menu2_3.vue?vue&type=script&lang=js&"
export * from "./menu2_3.vue?vue&type=script&lang=js&"
import style0 from "./menu2_3.vue?vue&type=style&index=0&id=65f43768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f43768",
  null
  
)

export default component.exports